import React from 'react';
import PropTypes from 'prop-types';
import { CategoryItem } from './CategoryItem';

export const CategoryList = (props) => {

    const { categories } = props;

    const cardPropsArr = [
        {
            img: '/images/bg-members.jpg',
        },
        {
            img: '/images/bg-forum.jpg',
        },
        {
            img: '/images/contact.jpg',
        },
    ]

    return (
        <div className="row">
            {
                categories && categories.length > 0 && categories.map((category, index) =>
                    <CategoryItem key={index} category={category} cardProps={cardPropsArr[index]} />
                )
            }
        </div>
    );
};

CategoryList.propTypes = {
    categories: PropTypes.array
}



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/elements/CategoryList.js